<template>
  <Dialog
      v-model:visible="showExpiryWarningProxy"
      modal
      class="w-[26rem] dark:bg-zinc-800 border-neutral-500"
      content-class="dark:text-white"
      :draggable="false"
      :closable="false"
      :dismissableMask="false"
      :closeOnEscape="false"
  >
    <template #header>
      <div class="inline-flex items-center gap-2">
        <span class="font-semibold text-2xl dark:text-white">
          {{ $t('message.session_timeout_title') }}
        </span>
      </div>
    </template>

    <div class="flex flex-col gap-4">
      <div class="text-sm text-neutral-600 dark:text-neutral-300">
        {{ $t('message.session_timeout_body') }}
      </div>
      <div class="text-4xl font-light text-neutral-700 dark:text-neutral-200">
        {{ formattedCountdown }}
      </div>
      <div class="text-sm text-neutral-600 dark:text-neutral-300">
        {{ $t('message.session_timeout_hint') }}
      </div>
      <div class="flex gap-3 justify-end pt-2">
        <Button
            :label="$t('label.continue')"
            class="bg-primary-500 border-primary-500 text-white"
            :loading="refreshing"
            @click="continueSession"
        />
        <Button
            :label="$t('label.logout')"
            outlined
            class="border-primary-500 text-primary-500"
            :disabled="refreshing"
            @click="logout"
        />
      </div>
    </div>
  </Dialog>

  <Dialog
      v-model:visible="showExpiredProxy"
      modal
      class="w-[26rem] dark:bg-zinc-800 border-neutral-500"
      content-class="dark:text-white"
      :draggable="false"
      :closable="false"
      :dismissableMask="false"
      :closeOnEscape="false"
  >
    <template #header>
      <div class="inline-flex items-center gap-2">
        <span class="font-semibold text-2xl dark:text-white">
          {{ $t('message.session_expired_title') }}
        </span>
      </div>
    </template>

    <div class="flex flex-col gap-4">
      <div class="text-sm text-neutral-600 dark:text-neutral-300">
        {{ $t('message.session_expired_body') }}
      </div>
      <div class="flex justify-end pt-2">
        <Button
            :label="$t('label.ok')"
            class="bg-primary-500 border-primary-500 text-white"
            @click="logout"
        />
      </div>
    </div>
  </Dialog>
</template>

<script>
import api, { refreshToken } from '../utils/api.js';

export default {
  data() {
    return {
      refreshing: false,
    };
  },

  computed: {
    showExpiryWarningProxy: {
      get() {
        return this.$store.getters['session/showExpiryWarning'];
      },
      set(value) {
        this.$store.commit('session/SET_WARNING_VISIBLE', value);
      },
    },
    showExpiredProxy: {
      get() {
        return this.$store.getters['session/showExpired'];
      },
      set(value) {
        this.$store.commit('session/SET_EXPIRED_VISIBLE', value);
      },
    },
    warningSecondsLeft() {
      return this.$store.getters['session/warningSecondsLeft'];
    },
    formattedCountdown() {
      const totalSeconds = Math.max(0, Number(this.warningSecondsLeft || 0));
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      const minLabel = 'min';
      const secLabel = 'sec';

      if (minutes > 0) {
        return `${minutes} ${minLabel} ${seconds} ${secLabel}`;
      }

      return `${seconds} ${secLabel}`;
    },
  },

  methods: {
    async continueSession() {
      if (this.refreshing) {
        return;
      }

      this.refreshing = true;

      try {
        await refreshToken();
        this.showExpiryWarningProxy = false;
      } catch {
        await this.$store.dispatch('clearStore');
        this.showExpiryWarningProxy = false;
        this.showExpiredProxy = true;
      } finally {
        this.refreshing = false;
      }
    },

    async logout() {
      try {
        await api.post('/logout');
      } catch (error) {
        console.warn('Logout API request failed', error);
      }

      await this.$store.dispatch('clearStore');
      this.showExpiryWarningProxy = false;
      this.showExpiredProxy = false;
      this.$router.replace('/login');
    },
  },
};
</script>
